import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const ColorSwatch = ({height, width}) => {
    return (
        <Box
            height={height}
            width={width}
            borderRadius="full"
            border="1px"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            padding="2px"
            _after={{
                content: '""',
                display: 'block',
                width: '100%',
                height: '100%',
                background:
                    'conic-gradient(from 90deg,rgba(196, 0, 0, 1) 0deg,rgba(207, 145, 0, 1) 42.3672deg,rgba(194, 198, 0, 1) 89.0472deg,rgba(0, 203, 20, 1) 139.213deg,rgba(0, 203, 239, 1) 190.542deg,rgba(26, 0, 224, 1) 234.911deg,rgba(196, 0, 173, 1) 311.412deg,rgba(196, 0, 0, 1) 360deg)',
                borderRadius: 'full'
            }}
        />
    )
}

ColorSwatch.propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default ColorSwatch
